import axiosClient from "./axiosClient";

const authService = {
  signup: (data) => axiosClient.post("/auth/signup", data),

  login: (email, password) =>
    axiosClient.post("/auth/login", null, { params: { email, password } }),

  forgotPassword: (email) =>
    axiosClient.post("/auth/forgot-password", null, { params: { email } }),

  getMe: () => axiosClient.get("/auth/me"),

  getUserById: (userId) => axiosClient.get(`/auth/user/${userId}`),

  getAllUsers: () => axiosClient.get("/auth/all"),
};

export default authService;
